import React from 'react';
import { Settings, Navigation, MapPin, FileText, Users, ShieldCheck, Landmark } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function GlobalParametrizacion() {
    const items = [
        { title: 'Datos de la Entidad', icon: Settings, href: '/parametrizacion/configuracion-entidad', color: 'bg-gray-700' },
        { title: 'Departamentos', icon: Navigation, href: '/parametrizacion/departamentos', color: 'bg-blue-500' },
        { title: 'Ciudades/Distritos', icon: MapPin, href: '/parametrizacion/ciudades', color: 'bg-blue-400' },
        { title: 'Barrios', icon: MapPin, href: '/parametrizacion/barrios', color: 'bg-blue-300' },
        { title: 'Sucursales', icon: Landmark, href: '/parametrizacion/sucursales', color: 'bg-indigo-600' },
        { title: 'Tipos de Documento', icon: FileText, href: '/parametrizacion/tipos-documento', color: 'bg-gray-500' },
        { title: 'Plantillas Documento', icon: FileText, href: '/parametrizacion/plantillas-documento', color: 'bg-gray-700' },
        { title: 'Parámetros Globales', icon: Settings, href: '/parametrizacion/parametros-globales', color: 'bg-indigo-800' },
    ];

    return (
        <div className="p-6">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-6 py-4 flex items-center space-x-4 bg-gray-100 text-gray-800">
                    <Settings className="w-8 h-8 opacity-80" />
                    <div>
                        <h3 className="text-xl font-bold">4. Módulo: Configuración Global y Geografía</h3>
                        <p className="text-sm opacity-90">Datos base que usa todo el sistema.</p>
                    </div>
                </div>

                <div className="p-6">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                        {items.map((table, idx) => (
                            <Link
                                key={idx}
                                to={table.href}
                                className="bg-gray-50 text-gray-800 border-gray-100 hover:bg-opacity-90 p-4 rounded-xl shadow-sm hover:shadow-md transition-all border flex flex-col items-center text-center group"
                            >
                                <div className={`p-3 rounded-full ${table.color} bg-opacity-10 mb-3 group-hover:scale-110 transition-transform`}>
                                    <table.icon className={`w-6 h-6 ${table.color.replace('bg-', 'text-')}`} />
                                </div>
                                <h4 className="font-bold text-sm text-gray-800 group-hover:text-blue-600 transition-colors leading-tight">{table.title}</h4>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
